/**
 * [http.ts]
 * @author willwuwei on 2022/05/19.
 */

import axios from 'axios';
import qs from 'qs';
import {
  Env, Storage, Toast, Fusion, Omega,
} from 'core';
import { useCommonStore } from 'store';
// import * as Sentry from '@sentry/browser';

// 配置接口地址
axios.defaults.baseURL = Env.APP_API_ENV;

// 配置超时时间
axios.defaults.timeout = 30e3;
// axios.defaults.withCredentials = true;
// 配置请求头
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// 自定义APIERROR对象
class ApiError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ApiError';
    this.message = message;
  }
}

function apiError(message: string, errno: number, errmsg: string, traceId: string) {
  const error = Object.create(ApiError.prototype);
  error.name = 'ApiError';
  error.message = message;
  error.errno = errno;
  error.errmsg = errmsg;
  error.traceId = traceId;
  return error;
}

// 添加请求拦截器
axios.interceptors.request.use(
  (req) => {
    req.params = {
      lang: Storage.getLang(),
      location_country: Storage.getCountry(),
      ticket: Storage.getTicket(),
      locale: Storage.getLocale(),
      location_cityid: Storage.getCityid(),
      caller: 'fleet_app',
      ...req.params,
    };
    return req;
  },
  (error) => Promise.reject(error),
);

// 添加响应拦截器
axios.interceptors.response.use(
  (response) => {
    const res = response?.data;
    // const { config } = response;
    if (res?.errno === 0) {
      return res?.data;
    }
    if (res?.errmsg) {
      Toast.error(res?.errmsg);
    }
    const { config } = response;

    Omega.traceApiError(config.baseURL || '', {
      path: config?.url || '',
      params: config?.params || config?.data,
      status: response?.status,
      code: res?.errno,
      msg: res?.errmsg || '',
      trace_id: res?.traceId || '',
    });

    if (res?.errno === 10005) {
      if (Fusion?.exitLogin) {
        Fusion.exitLogin({});
      } else {
        const commonStore = useCommonStore();
        commonStore.setIsUnauth(true);
      }
    }
    return Promise.reject(apiError(res?.errmsg, res?.errno, res?.errmsg, res?.traceId));
  },
  (error) => {
    const { config } = error;

    Omega.traceApiError(config.baseURL || '', {
      path: config?.url || '',
      params: config?.params || config?.data,
      status: error?.response?.status || error?.status,
      code: error?.data?.errno || error?.code,
      msg: error?.data?.errmsg || error?.message,
      trace_id: error?.data?.traceId || '',
    });
    Promise.reject(error);
  },
);

export default {
  get: (url: string, arg?: any, config?: any) => axios.get(arg ? `${url}?${qs.stringify(arg)}` : url, config),
  post: (url: string, arg?: any, config?: any) => axios.post(url, qs.stringify(arg), config),
  put: (url: string, arg: any, config?: any) => axios.put(url, qs.stringify(arg), config),
  del: (url: string, arg: any, config?: any) => axios.delete(arg ? `${url}?${qs.stringify(arg)}` : url, config),
  putForm: (url: string, arg: any, config?: any) => {
    const formData = new FormData();
    if (arg) {
      Object.keys(arg).forEach((k) => formData.append(k, arg[k]));
    }
    return axios.put(url, formData, {
      'Content-Type': 'multipart/form-data',
      ...config,
    });
  },
  postForm: (url: string, arg: any, config?: any) => {
    const formData = new FormData();
    if (arg) {
      Object.keys(arg).forEach((k) => formData.append(k, arg[k]));
    }
    return axios.post(url, formData, {
      'Content-Type': 'multipart/form-data',
      ...config,
    });
  },
  postJson: (url: string, arg: any, config?: any) => axios.post(url, arg, {
    'Content-Type': 'application/json;charset=UTF-8',
    ...config,
  }),
  postBlob: (url: string, arg: any) => axios.post(url, arg, {
    responseType: 'blob',
  }),
};
